export class PropertyManagementCompanyUser {
    id: number;
    propertyManagementCompanyId: number;
    userId: number;

    constructor(obj: any) {
        this.id = obj.id || null;
        this.propertyManagementCompanyId = obj.propertyManagementCompanyId || null;
        this.userId = obj.userId || null;
    }
}
